import { render } from "./NewPage.vue?vue&type=template&id=77f9f6f2"
import script from "./NewPage.vue?vue&type=script&lang=js"
export * from "./NewPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__